import React from "react";
import { useContext } from "react";
import { useState, useEffect } from "react";
import Paho from "paho-mqtt";
import { VARIABLES } from "../Constant";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import { createContext } from "react";
import { StateContext } from "../Context/StateContext";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const { lastScheduleIndexRef, bulkSchedulerUpload } =
    useContext(StateContext);

  const [ackPayloadMessage, setAckPayloadMessage] = useState(null);

  const [isConnected, setIsConnected] = useState(true);

  const [pumpChecked, setPumpChecked] = useState(null);
  console.log(pumpChecked);

  const [mqttClient, setMqttClient] = useState(null);
  console.log(mqttClient);

  const [formatted, setFormatted] = useState({});
  console.log(formatted);

  const getMqttConnection = () => {
    console.log(`REACT-${VARIABLES.mqtt_client_test}-MQTT`);
    // Replace with your MQTT broker URL
    const client = new Paho.Client(
      "wss://mqtt.elorca.com:9001/mqtt",
      `REACT-${uuidv4()}-MQTT`
    );
    // const client = new Paho.Client('mqtt.elorca.com', 9001, 'REACT-1-MQTT');
    client.debug = true;
    client.onConnectionLost = (responseObject) => {
      if (responseObject.errorCode !== 0) {
        console.log(`Connection lost: ${responseObject.errorMessage}`);
        setIsConnected(false);
        // Attempt to reconnect
        // client.connect();
      }
    };
    client.connect({
      keepAliveInterval: 60, // in seconds
      onSuccess: () => {
        console.log("Connected to MQTT broker");
        const mqtt_topic_one = "zoomsolar/AD0E9446/+/+/feedback";
        const mqtt_topic_two =
          "zoomsolar/AD0E9446/+/reading/values/timer_cmd/ack";
        client.subscribe(mqtt_topic_one, { qos: 2 });
        client.subscribe(mqtt_topic_two, { qos: 2 });
        setMqttClient(client);
        setIsConnected(true);
      },
      useSSL: true, // if your broker requires SSL
      // reconnect: true, // enable automatic reconnection
      onFailure: (error) => {
        console.error(
          `Connection failed - ErrorCode: ${error.errorCode}, ErrorMessage: ${error.errorMessage}, Stack: ${error.stack}`
        );
        setIsConnected(false);
      },
    });

    client.onMessageArrived = (message) => {
      console.log(message.destinationName);
      // const lastPart = message.destinationName.split("/").slice(-2).join("/");
      const lastPart = message.destinationName.split("/");
      if (lastPart.includes("timer_cmd")) {
        console.log(message.payloadString);
        setAckPayloadMessage(message.payloadString);
      } else if (lastPart.includes("feedback")) {
        console.log(message.payloadString);
        console.log(`Message arrived on topic: ${message.destinationName}`);
        const split_entity_data = message.destinationName.split("/");
        console.log(split_entity_data);
        const feedback_value = parseInt(message.payloadString);
        const feedback_pin_split = message.payloadString?.split("?");

        setFormatted((prevData) => {
          const newData = { ...prevData };

          let temp = newData;

          for (let i = 0; i < split_entity_data.length - 2; i++) {
            const mqtt_data = split_entity_data[i];
            temp[mqtt_data] = temp[mqtt_data] || {};
            temp = temp[mqtt_data];
          }

          const pin = split_entity_data[split_entity_data.length - 2];
          console.log(pin);
          temp[pin] = temp[pin] || 0;
          temp[pin] = feedback_value;

          return { ...newData };
        });
      } else {
        console.log("Unknown topic message arrived:", message.destinationName);
      }
    };

    return () => {
      if (client.isConnected()) client.disconnect();
      setIsConnected(false);
    };
  };

  useEffect(() => {
    getMqttConnection();
  }, []);

  useEffect(() => {
      if (!ackPayloadMessage) return;
  
      if (lastScheduleIndexRef.current === ackPayloadMessage) {
        Swal.fire({
          icon: "success",
          title: "Scheduler Added Successfully",
          showConfirmButton: true,
        });
  
        bulkSchedulerUpload();
      }
  
      // Reset state so next same payload works again
      setAckPayloadMessage(null);
    }, [ackPayloadMessage]);

  return (
    <AppContext.Provider
      value={{
        formatted,
        setPumpChecked,
        pumpChecked,
        setFormatted,
        mqttClient,
        isConnected,
        setIsConnected,
        getMqttConnection,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
const useGlobalContext = () => {
  return useContext(AppContext);
};
export { AppContext, AppProvider, useGlobalContext };
